import { Progress } from "antd";
import React, { useContext } from "react";
import { ProgressContext } from "../utils/ProgressContext";
import {
  CloseCircleFilled,
  SyncOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";

const PlaidSyncProgressLoader = ({ percent }) => {
  const { stopLoadingCross, message } = useContext(ProgressContext);

  return (
    <div
      style={{
        backdropFilter: "blur(18px)",
        WebkitBackdropFilter: "blur(18px)",
        position: "fixed",
        bottom: "24px",
        right: "24px",
        left: "auto",
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(246, 248, 255, 0.96) 100%)",
        border: "1px solid rgba(42, 61, 163, 0.12)",
        borderRadius: "18px",
        boxShadow:
          "0 18px 50px rgba(15, 23, 42, 0.16), 0 6px 18px rgba(42, 61, 163, 0.10)",
        padding: "16px 18px 14px",
        width: "min(420px, calc(100vw - 32px))",
        minHeight: "112px",
        height: "auto",
        zIndex: 99999999999999,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {message ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "80px",
            textAlign: "center",
            padding: "8px 6px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              color: "#0f7b3e",
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: 1.35,
            }}
          >
            <CheckCircleFilled style={{ fontSize: "18px" }} />
            <span>{message}</span>
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "12px",
            }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "999px",
                  display: "grid",
                  placeItems: "center",
                  background: "rgba(42, 61, 163, 0.10)",
                  color: "#2a3da3",
                  flexShrink: 0,
                }}
              >
                <SyncOutlined spin />
              </div>
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontWeight: 800,
                    fontSize: "15px",
                    color: "#111827",
                    lineHeight: 1.2,
                  }}
                >
                  Updating accounts
                </div>
                <div style={{ color: "#6b7280", fontSize: "12px", marginTop: "2px" }}>
                  Your Plaid data is syncing in the background
                </div>
              </div>
            </div>
            <span
              onClick={() => {
                stopLoadingCross();
              }}
              style={{
                cursor: "pointer",
                fontWeight: "bold",
                color: "#64748b",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: "28px",
                height: "28px",
                borderRadius: "999px",
                transition: "background-color 0.15s ease, color 0.15s ease",
              }}
              onMouseEnter={(event) => {
                event.currentTarget.style.backgroundColor = "rgba(15, 23, 42, 0.06)";
                event.currentTarget.style.color = "#111827";
              }}
              onMouseLeave={(event) => {
                event.currentTarget.style.backgroundColor = "transparent";
                event.currentTarget.style.color = "#64748b";
              }}
            >
              <CloseCircleFilled />
            </span>
          </div>
          <div style={{ paddingLeft: "46px" }}>
            <Progress
              percent={percent}
              size="small"
              strokeColor={{
                "0%": "#2a3da3",
                "100%": "#09a84d",
              }}
              trailColor="rgba(42, 61, 163, 0.12)"
              showInfo={false}
              strokeWidth={12}
              style={{ marginTop: "2px" }}
            />
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                color: "#6b7280",
                fontSize: "12px",
                gap: "10px",
              }}
            >
              <span>Progress is being updated live</span>
              <span style={{ fontWeight: 700, color: "#2a3da3" }}>
                {Math.max(0, Math.min(100, Number(percent) || 0))}%
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlaidSyncProgressLoader;
